class CartDiscount extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.discount-form');
    this.input = this.form.querySelector('input');
    this.error = this.form.querySelector('p.error');
    this.submitButton = this.form.querySelector('.submit-discount');
    this.removeButtons = this.querySelectorAll('.remove-discount');

    this.enteredDiscountCode = '';
    this.discountCodes = this.dataset.discountCodes ? this.dataset.discountCodes.split(',').filter(Boolean) : [];

    this.handleApply = this.handleApply.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  connectedCallback() {
    this.submitButton.addEventListener('click', this.handleApply);
    this.removeButtons.forEach((btn) =>
      btn.addEventListener('click', this.handleRemove)
    );
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.handleApply);
    this.removeButtons.forEach((btn) =>
      btn.removeEventListener('click', this.handleRemove)
    );
  }

  async handleApply(e) {
    e.preventDefault();

    const discountCode = this.input.value.trim();
    this.error.style.display = 'none';

    if (!discountCode) {
      this.showError(this.error.dataset.notValid || 'Discount code not found.');
      return;
    }

    if (this.discountCodes.includes(discountCode)) {
      this.showError(this.error.dataset.applied || 'Entered coupon was already applied.');
      return;
    }

    this.enteredDiscountCode = discountCode;
    const newCodes = [...this.discountCodes, discountCode];

    try {
      await fetch(`/checkout?discount=${newCodes.join(',')}`, {
        method: 'GET',
      });
      await this.reloadCart();
    } catch (error) {
      console.error('Failed to apply discount:', error);
      this.showError('Something went wrong.');
    }
  }

  async handleRemove(e) {
    const discountCode = e.currentTarget.dataset.code;
    const remainCodes = this.discountCodes.filter((c) => c !== discountCode);

    try {
      await fetch(`/checkout?discount=${remainCodes.join(',')}`, {
        method: 'GET',
      });
      this.refreshCart();
    } catch (error) {
      console.error('Failed to remove discount:', error);
    }
  }

  async reloadCart() {
    try {
      const response = await fetch('/cart.js');
      const data = await response.json();
      const applied = this.extractAppliedDiscounts(data);

      if (!applied.map(code => code.toLowerCase()).includes(this.enteredDiscountCode.toLowerCase())) {
        this.showError(this.error.dataset.notValid || 'Discount code not found.');
      } else {
        this.refreshCart();
      }
    } catch (error) {
      console.error('Failed to reload cart:', error);
      this.showError('Unable to verify discount.');
    }
  }

  extractAppliedDiscounts(cart) {
    const applied = [];

    cart.cart_level_discount_applications.forEach((d) => {
      if (d.type === 'discount_code') applied.push(d.title);
    });

    cart.items.forEach((item) => {
      item.line_level_discount_allocations.forEach((d) => {
        if (d.discount_application.type === 'discount_code') applied.push(d.discount_application.title);
      });
    });

    return [...new Set(applied)];
  }

  refreshCart() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.refreshCartSections === 'function') {
      cartItems.refreshCartSections();
    } else {
      window.location.reload();
    }
  }

  showError(message) {
    this.error.textContent = message;
    this.error.style.display = 'block';
  }
}

customElements.define('cart-discount', CartDiscount);